// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import useUuid from '../../../../hooks/useUuid';

const SVGElement = styled.svg``;

type OutcomeLoaderSvgAsComponentProps = {
  className?: string;
  key?: string;
};

const OutcomeLoaderSvgAsComponent = ({ className, key }: OutcomeLoaderSvgAsComponentProps) => {
  const uuid = useUuid();
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const uniqueIdentifier = `${uuid}${key ? `__${key}` : ''}`;

  return (
    <SVGElement className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12C9.76142 12 12 9.76142 12 7C12 6.44772 12.4477 6 13 6C13.5523 6 14 6.44772 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C7.55228 0 8 0.447715 8 1C8 1.55228 7.55228 2 7 2Z"
          fill={`url(#outcome-loader-svg-${uniqueIdentifier})`}
        />
        <circle
          cx="7"
          cy="7"
          r="6"
          stroke="var(--OutcomeLoaderSvgAsComponentSecondaryColor)"
          strokeOpacity="0.3"
          strokeWidth="2"
        />
      </g>
      <defs>
        <linearGradient
          id={`outcome-loader-svg-${uniqueIdentifier}`}
          x1="5.5"
          y1="7"
          x2="12"
          y2="7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--OutcomeLoaderSvgAsComponentPrimaryColor)" />
          <stop offset="1" stopColor="var(--OutcomeLoaderSvgAsComponentPrimaryColor)" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SVGElement>
  );
};

export default OutcomeLoaderSvgAsComponent;
